import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import Select from 'react-select';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import CostCentreService from 'services/CostCentreService';
import VendorService from 'services/VendorService';
import CurrencyService from 'services/CurrencyService';
import BootboxHelper from 'helpers/BootboxHelper';
import LocationService from 'services/LocationService';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class EditCostCentreModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.costCentreID = opts.costCentreID;
            this.vendorID = opts.vendorID;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true,
                isLoading: true
            });
            this.load();
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    async load() {
        let costCentre;
        const vendors = await VendorService.list();
        const geos = await LocationService.listGeos();

        if (this.costCentreID) {
            costCentre = await CostCentreService.get(this.costCentreID);
        } else {
            costCentre = {
                vendorID: this.vendorID || vendors[0].id
            };
        }

        const currencies = await CurrencyService.list();

        this.setState({
            costCentre,
            vendors,
            currencies,
            geos,
            isLoading: false
        });
    }

    updateFields(values) {
        const costCentre = { ...this.state.costCentre };
        for (var field in values) {
            let value = values[field];
            costCentre[field] = value;
        }
        this.setState({
            costCentre: costCentre
        });
    }

    async saveAndClose() {
        this.setState({
            isLoading: true
        });
        try {
            await CostCentreService.save(this.state.costCentre);
            this.close();
            this.resolve();
        } catch (error) {
            BootboxHelper.alert(error);
            this.setState({
                isLoading: false
            });
        }
    }

    async confirmDelete() {
        const confirm = await BootboxHelper.confirm('Are you sure you want to delete this cost centre?');
        if (confirm) {
            this.delete();
        }
    }

    async delete() {
        this.setState({
            isLoading: true
        });
        await CostCentreService.delete(this.state.costCentre.id);
        this.close();
        this.resolve();
    }

    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (<>

            <Modal show className="edit-cost-centre-modal">
                {this.renderInner()}
            </Modal>

        </>);
    }

    renderInner() {
        const {
            isLoading,
            costCentre,
            vendors,
            geos
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            );
        }

        return (

            <form onSubmit={e => { e.preventDefault(); this.saveAndClose() }}>
                <Modal.Body>

                    <Form.Group className="mb-3">
                        <Form.Label>Vendor</Form.Label>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            value={costCentre.vendorID ? vendors.find(v => v.id == costCentre.vendorID) : null}
                            options={vendors}
                            getOptionValue={v => v.id}
                            getOptionLabel={v => v.name}
                            onChange={v => this.updateFields({ vendorID: v.id })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Geo</Form.Label>
                        <select
                            className="form-control"
                            value={costCentre.geoID || ''}
                            onChange={e => this.updateFields({ geoID: parseInt(e.target.value) })}
                        >
                            {geos.map(g =>
                                <option key={g.id} value={g.id}>
                                    {g.name}
                                </option>
                            )}
                        </select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <input
                            className="form-control"
                            type="text"
                            value={costCentre.name || ''}
                            onChange={e => this.updateFields({ name: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Short name (appears for accountant)</Form.Label>
                        <input
                            className="form-control"
                            type="text"
                            value={costCentre.shortName || ''}
                            onChange={e => this.updateFields({ shortName: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>PO number</Form.Label>
                        <input
                            className="form-control"
                            type="text"
                            value={costCentre.poNumber || ''}
                            onChange={e => this.updateFields({ poNumber: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="">
                        <Form.Label>Options</Form.Label>
                        <Form.Check
                            type="checkbox"
                            id="is-default"
                            checked={costCentre.isDefault || false}
                            onChange={e => this.updateFields({ isDefault: e.target.checked })}
                            label="Default cost centre for this vendor & geo"
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                        Close
                    </button>
                    {costCentre.id &&
                        <button type="button" className="btn btn-danger ms-auto me-auto" onClick={() => this.confirmDelete()}>
                            Delete
                        </button>
                    }
                    <button type="submit" className="btn btn-primary ms-auto">
                        Save
                    </button>
                </Modal.Footer>
            </form>
        );
    }
}

export default EditCostCentreModal;